// extracted by mini-css-extract-plugin
export default {"genericCard":"gr-z","inline":"hr-z","mastercard":"ir-z","discover":"jr-z","visa":"kr-z","amex":"lr-z","active":"mr-z"};